import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { I18nModule, CmsConfig, ConfigModule } from '@spartacus/core';
import { CmsCommonModule } from '../cms-common/cms-common.module';

import { MatTableModule } from '@angular/material/table';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { CustomStartOrderComponent } from './custom-start-order.component';
import { QuantitypopupComponent } from './quantitypopup/quantitypopup.component';




@NgModule({
  declarations: [
    CustomStartOrderComponent,
    QuantitypopupComponent,
  ],
  



  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    I18nModule,
    CmsCommonModule,

    // ✅ Angular Material
    MatTableModule,
    MatProgressBarModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonModule,
    MatIconModule,

    // ✅ Spartacus CMS config
    ConfigModule.withConfig({
      cmsComponents: {
        StartOrderThankyouComponent: {
          component: CustomStartOrderComponent,
        },
      }
    } as CmsConfig)
  ]
})
export class CustomStartOrderModule {}
